import { useEffect, useRef, useState } from "react";
import loaderGif from "../img/gif_cargas/Tr.gif";

const GlobalLoader = () => {
  const [visible, setVisible] = useState(true);
  const hideTimer = useRef(null);

  useEffect(() => {
    const showLoader = () => {
      if (hideTimer.current) {
        clearTimeout(hideTimer.current);
        hideTimer.current = null;
      }
      setVisible(true);
    };

    const hideLoader = () => {
      if (hideTimer.current) {
        clearTimeout(hideTimer.current);
      }
      hideTimer.current = setTimeout(() => {
        setVisible(false);
        hideTimer.current = null;
      }, 1000);
    };

    if (document.readyState === "complete") {
      hideLoader();
    }

    const handleWindowLoad = () => {
      hideLoader();
    };

    const handleBeforeUnload = () => {
      showLoader();
    };

    const handleLinkClick = (event) => {
      if (event.defaultPrevented) return;

      const anchor = event.target.closest("a");
      if (!anchor) return;

      const href = anchor.getAttribute("href");
      if (!href || href.startsWith("#")) return;

      const target = anchor.getAttribute("target");
      if (target && target !== "_self") return;

      showLoader();
    };

    const handleFormSubmit = (event) => {
      if (event.defaultPrevented) return;
      showLoader();
    };

    window.addEventListener("load", handleWindowLoad);
    window.addEventListener("beforeunload", handleBeforeUnload);
    document.addEventListener("click", handleLinkClick);
    document.addEventListener("submit", handleFormSubmit);

    return () => {
      if (hideTimer.current) {
        clearTimeout(hideTimer.current);
      }
      window.removeEventListener("load", handleWindowLoad);
      window.removeEventListener("beforeunload", handleBeforeUnload);
      document.removeEventListener("click", handleLinkClick);
      document.removeEventListener("submit", handleFormSubmit);
    };
  }, []);

  return (
    <div className={`global-loader${visible ? " is-visible" : ""}`}>
      <img src={loaderGif} alt="Cargando contenido" />
    </div>
  );
};

export default GlobalLoader;
